import { useState, useEffect } from "react";
import { supabase } from "../components/SupabaseClient";

/**
 * Hook to fetch user details from Supabase RPC
 * @returns {Object} User data state and functions
 */
export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const { data, error } = await supabase.rpc("get_user_details");

      if (error) {
        throw error;
      }

      setUsers(data || []);
    } catch (err) {
      setError(err.message);
      console.error("Failed to fetch users:", err);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshUsers = async () => {
    await fetchUsers();
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    loading,
    error,
    refreshUsers,
  };
};
